import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { TenantScheduleJob } from 'src/app/shared/models/tenant-schedule-job';
import { TenantScheduleJobResponse } from '../../models/tenant-schedule-job-response';
import { TenantApiService } from '../http/tenant-api.service';
import AutoMapperService from './auto-mapper.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TenantScheduleJobService {
    public constructor(private tenantApiService: TenantApiService) {}

    public getTenantScheduleJobs(tenantId: string, scheduleId: number): Observable<TenantScheduleJob[]> {
        return this.tenantApiService.getTenantScheduleJobs(tenantId, scheduleId).pipe(
            map(response => {
                const jobs: TenantScheduleJob[] =
                    response?.map(data =>
                        AutoMapperService.mapToApplicationModel<TenantScheduleJobResponse, TenantScheduleJob>(data)
                    ) ?? [];

                jobs.forEach(j => AutoMapperService.convertStringsToDates(j, 'lastRunUtc'));

                return jobs;
            })
        );
    }

    public saveTenantScheduleJobs(tenantId: string, scheduleId: number, jobs: number[]) {
        return this.tenantApiService.saveTenantScheduleJobs(tenantId, scheduleId, jobs);
    }

    public removeTenantScheduleJobs(tenantId: string, scheduleId: number, jobs: number[]) {
        return this.tenantApiService.removeTenantScheduleJobs(tenantId, scheduleId, jobs);
    }
}
